/** Сегодня по часам человека — `ГГГГ-ММ-ДД` (дата документа 1С местная, без пояса). */
export function localToday(now = new Date()): string {
  const month = String(now.getMonth() + 1).padStart(2, '0')
  const day = String(now.getDate()).padStart(2, '0')
  return `${now.getFullYear()}-${month}-${day}`
}
